// JOH World — gedeelde canvas-engine: assets, particles, zwevende teksten, pixels.
export const VW = 384;  // interne canvas-resolutie (16:9 retro)
export const VH = 216;

export const PAL = {
  black: "#0A0A0A",
  yellow: "#FFC61A",
  cream: "#F5F3F0",
  red: "#E8362A",
  darkRed: "#8C2318",
  brown: "#7A4A21",
  wood: "#9C6B30",
  woodDark: "#6B4423",
  grey: "#2A2A2E",
  greyLight: "#4A4A50",
  green: "#5C7A4A",
  beige: "#E8D9B8",
  metal: "#8A8A92",
};

const fighterImg = new Image();
fighterImg.src = "/johworld/fighter.png";
export const logoImg = new Image();
logoImg.src = "/johworld/logo.png";

export function fighterReady() { return fighterImg.complete && fighterImg.naturalWidth > 0; }
export function getFighter() { return fighterImg; }

// Handschoen-ankers (genormaliseerd, uit de asset-analyse): voorkant vuist rechts.
export const GLOVE_FRONT = { x: 0.97, y: 0.50 };

// ---------- Particles ----------
export class Particles {
  constructor() { this.list = []; }
  burst(x, y, color, n = 10, speed = 60, life = 0.5, size = 2) {
    for (let i = 0; i < n; i++) {
      const a = Math.random() * Math.PI * 2;
      const v = speed * (0.4 + Math.random() * 0.8);
      this.list.push({
        x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 30,
        life: life * (0.6 + Math.random() * 0.8), age: 0, color, size,
      });
    }
  }
  update(dt) {
    for (const p of this.list) { p.age += dt; p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 220 * dt; }
    this.list = this.list.filter((p) => p.age < p.life);
  }
  draw(ctx, camX = 0) {
    for (const p of this.list) {
      ctx.globalAlpha = Math.max(0, 1 - p.age / p.life);
      ctx.fillStyle = p.color;
      ctx.fillRect(Math.round(p.x - camX), Math.round(p.y), p.size, p.size);
    }
    ctx.globalAlpha = 1;
  }
}

// ---------- Zwevende teksten ("NICE DUCK!", "+10") ----------
export class FloatTexts {
  constructor() { this.list = []; }
  add(x, y, text, color = PAL.yellow, size = 8, life = 1.1) {
    this.list.push({ x, y, text, color, size, life, age: 0 });
  }
  update(dt) {
    for (const f of this.list) { f.age += dt; f.y -= 18 * dt; }
    this.list = this.list.filter((f) => f.age < f.life);
  }
  draw(ctx, camX = 0) {
    for (const f of this.list) {
      ctx.globalAlpha = Math.max(0, 1 - (f.age / f.life) ** 2);
      pixelText(ctx, f.text, f.x - camX, f.y, f.size, f.color, "center");
    }
    ctx.globalAlpha = 1;
  }
}

export function pixelText(ctx, text, x, y, size = 8, color = PAL.cream, align = "left") {
  ctx.font = `${size}px "Press Start 2P", monospace`;
  ctx.textAlign = align;
  ctx.textBaseline = "top";
  ctx.fillStyle = "#000";
  ctx.fillText(text, Math.round(x) + 1, Math.round(y) + 1);
  ctx.fillStyle = color;
  ctx.fillText(text, Math.round(x), Math.round(y));
  ctx.textAlign = "left";
}

export function fmtTime(ms) {
  const m = Math.floor(ms / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  const cs = Math.floor((ms % 1000) / 10);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}.${String(cs).padStart(2, "0")}`;
}
